const initialState = {
    user: '',
 
    noData: false,
    unprocessedRecordsList: [],
    productLines: [],
    manufacturerCodes: [],
    publishedTemplateNames: [],
    unpublishedTemplateNames: [],
    filter: [],
    showAll: false,
    percent_complete: 0,
    progress_activate: true,
    complete_export: false,
    complete_import: false,
    fetching: false,
    fetched: false,
    error: null,
    page: 1,
    pages: 0,
    sortedList: [],
    reprocessMsg: "",
    jobInfo: null
}

export function unprocessedRecordsReducer(state = initialState, action) {
  
    switch (action.type) {
        case "SET_USER": {
            return { ...state, user: action.payload.data.user }
        }

        case "FETCH_UNPROCESSED_RECORDS": {
            return { ...state, fetching: true, fetched: false, page: action.payload.data.page, error: null }
        }
        case "FETCH_UNPROCESSED_RECORDS_REJECTED": {
            return { ...state, fetching: false, error: action.payload }
        }
        case "FETCH_UNPROCESSED_RECORDS_FULFILLED": {
            let UnprocessedRecs

            if (state.page === 1)
            {
                UnprocessedRecs = action.payload.data.unprocessedRecords;
            }
            else {
                UnprocessedRecs = Object.assign([], state.unprocessedRecordsList)
                action.payload.data.unprocessedRecords.forEach((rec) => UnprocessedRecs.push(rec))
            }

            return {
                ...state,
                fetching: false,
                fetched: true,
                noData: UnprocessedRecs.length == 0, 
                productLines: action.payload.data.productLines,
                manufacturerCodes: action.payload.data.manufacturerCodes,
                publishedTemplateNames: action.payload.data.publishedTemplateNames,
                unpublishedTemplateNames: action.payload.data.unpublishedTemplateNames,
                pages: action.payload.data.totalRecords,
                unprocessedRecordsList: UnprocessedRecs

            };
        }

        case "SORT_BRPRID": {
            let list = Object.assign([], action.payload.list)

            list.sort(function (a, b) {
                if (a.brprid < b.brprid)
                    return action.payload.data ? -1 : 1
                else if (a.brprid > b.brprid)
                    return action.payload.data ? 1 : -1
                else
                    return 0
            })

            return { ...state, unprocessedRecordsList: list }
        }
        case "SORT_BRMFG": {
            let list = Object.assign([], action.payload.list)

            list.sort(function (a, b) {
                if (a.brmfg.toLowerCase() < b.brmfg.toLowerCase())
                    return action.payload.data ? -1 : 1
                else if (a.brmfg.toLowerCase() > b.brmfg.toLowerCase())
                    return action.payload.data ? 1 : -1
                else
                    return 0
            })

            return { ...state, unprocessedRecordsList: list }
        }
        case "SORT_BRLIN": {
            let list = Object.assign([], action.payload.list)

            list.sort(function (a, b) {
                if (a.brlin.toLowerCase() < b.brlin.toLowerCase())
                    return action.payload.data ? -1 : 1
                else if (a.brlin.toLowerCase() > b.brlin.toLowerCase())
                    return action.payload.data ? 1 : -1
                else
                    return 0
            })

            return { ...state, unprocessedRecordsList: list }
        }
        case "SORT_BRPART": {
            let list = Object.assign([], action.payload.list)

            list.sort(function (a, b) {
                if (a.brpart.toLowerCase() < b.brpart.toLowerCase())
                    return action.payload.data ? -1 : 1
                else if (a.brpart.toLowerCase() > b.brpart.toLowerCase())
                    return action.payload.data ? 1 : -1
                else
                    return 0
            })

            return { ...state, unprocessedRecordsList: list }
        }
        case "SORT_BRDES1": {
            let list = Object.assign([], action.payload.list)
            list.sort(function (a, b) {
                if (a.brdeS1.toLowerCase() < b.brdeS1.toLowerCase())
                    return action.payload.data ? -1 : 1
                else if (a.brdeS1.toLowerCase() > b.brdeS2.toLowerCase())
                    return action.payload.data ? 1 : -1
                else
                    return 0
            })

            return { ...state, unprocessedRecordsList: list }
        }
        case "SORT_BRDES2": {
            let list = Object.assign([], action.payload.list)

            list.sort(function (a, b) {
                if (a.brdeS2.toLowerCase() < b.brdeS2.toLowerCase())
                    return action.payload.data ? -1 : 1
                else if (a.brdeS2.toLowerCase() > b.brdeS2.toLowerCase())
                    return action.payload.data ? 1 : -1
                else
                    return 0
            })

            return { ...state, unprocessedRecordsList: list }
        }
        case "SORT_BRDES3": {
            let list = Object.assign([], action.payload.list)

            list.sort(function (a, b) {
                if (a.brdeS3.toLowerCase() < b.brdeS3.toLowerCase())
                    return action.payload.data ? -1 : 1
                else if (a.brdeS3.toLowerCase() > b.brdeS3.toLowerCase())
                    return action.payload.data ? 1 : -1
                else
                    return 0
            })

            return { ...state, unprocessedRecordsList: list }
        }
        case "SORT_TEMPLATEID": {
            let list = Object.assign([], action.payload.list)

            list.sort(function (a, b) {
                if (a.productTemplateId < b.productTemplateId)
                    return action.payload.data ? -1 : 1
                else if (a.productTemplateId > b.productTemplateId)
                    return action.payload.data ? 1 : -1
                else
                    return 0
            })

            return { ...state, unprocessedRecordsList: list }
        }
        case "SORT_TEMPLATENAME": {
            let list = Object.assign([], action.payload.list)
            
            list.sort(function (a, b) {
                if (a.productTemplateName === null) {
                    a.productTemplateName = "";
                }
                if (b.productTemplateName === null) {
                    b.productTemplateName = "";
                }
                if (a.productTemplateName.toString().toLowerCase() < b.productTemplateName.toString().toLowerCase())
                    return action.payload.data ? -1 : 1
                else if (a.productTemplateName.toString().toLowerCase() > b.productTemplateName.toString().toLowerCase())
                    return action.payload.data ? 1 : -1
                else
                    return 0
            })

            return { ...state, unprocessedRecordsList: list }
        }
        case "SORT_SUPPLEMENTAL_MISSING": {
            let list = Object.assign([], action.payload.list)

            list.sort(function (a, b) {
                if (a.supplementalDataMissing.toString().toLowerCase() < b.supplementalDataMissing.toString().toLowerCase())
                    return action.payload.data ? -1 : 1
                else if (a.supplementalDataMissing.toString().toLowerCase() > b.supplementalDataMissing.toString().toLowerCase())
                    return action.payload.data ? 1 : -1
                else
                    return 0
            })

            return { ...state, unprocessedRecordsList: list }
        }

        case "FETCH_UNPROCESSED_RECORDS_ERROR": {
            return { ...state, error: null }

        }
        case "PROCESS_FILTER_SELECTION": {
            return { ...state, fetching: false, fetched: true, filter: action.payload.data }
        }

        case "REPROCESS_IMPORT": {
            return { ...state, fetching: true, fetched: false, error: null }
        }
        case "REPROCESS_IMPORT_FULFILLED": {
            return { ...state, fetching: false, fetched: true, reprocessMsg: action.payload.data.statusMessage }
        }

        case "REPROCESS_IMPORT_REJECTED": {
            return { ...state, fetching: false, error: action.payload.response }
        }

        case "SHOW_ALL_RECORDS": {
            return { ...state, fetching: false, fetched: true, showAll: action.payload.data }
        }

        case "SORT_ALL_RECORDS": {
            return { ...state, fetching: false, fetched: true, unprocessedRecordsList: action.payload.data }
        }

        case "EXPORT_EXCEL": {
            return { ...state, fetching: false, fetched: true, filter: action.payload.data }
        }

        case "PERCENTAGE_COMPLETE": {
            return { ...state, fetching: false, fetched: true, percent_complete: action.payload.data }
        }        
        case "EXPORT_START": {
            return { ...state, fetching: false, fetched: true, complete_export: action.payload.data, jobInfo: null }
        }    
        case "FINISH_EXPORT": {
            return { ...state, fetching: false, fetched: true, percent_complete: action.payload.data }
        }
        case "COMPLETE_EXPORT": {
            return { ...state, fetching: false, fetched: true, complete_export: action.payload.data }
        }    
        case "FINISH_IMPORT": {
            return { ...state, fetching: false, fetched: true, percent_complete: action.payload.data }
        }

        case "IMPORT_START": {
            return { ...state, fetching: false, fetched: true, complete_import: action.payload.data, jobInfo: null }
        } 

        case "COMPLETE_IMPORT": {
            return { ...state, fetching: false, fetched: true, complete_import: action.payload.data }
        } 

        case "IMPORT_INFO":
        case "EXPORT_INFO": {
            return { ...state, jobInfo: action.payload.data }
        }

        case "CLEAR_EXPORT": {
            return { ...state, jobInfo: null }
        }

        case "NODATA_ERROR_CLEAR": {
            return { ...state, noData: false }
        }
           
        default:
            return state
    }
}
